module.exports = __webpack_public_path__ + "media/images/signup-magnet-f2de7773a586245caad1c93d28ccc5ea.jpg";